import { UI_STYLES } from "@/styles/uiStyles"


interface ChatContentWithoutPremiumProps {
    navigateToSubscription: () => void;
}

export const ChatContentWithoutPremium = ({navigateToSubscription}: ChatContentWithoutPremiumProps) => {

    return (
        <div className="w-full max-w-md mx-auto flex flex-col items-center mb-8 h-full justify-center">
        <p className="text-white/60 text-center mb-4 text-sm">
          Оформляйте подписку и участвуйте каждые две недели в поиске
          Счастливой карты, в случае выигрыша задайте вопрос нашему
          астрологу
        </p>
        <button
          className={`w-full max-w-xs py-3 rounded-xl ${UI_STYLES.buttonGradient} ${UI_STYLES.buttonGradientHover} text-white  text-base shadow`}
          onClick={() => navigateToSubscription()}
        >
          Оформить подписку
        </button>
      </div>
    )
}